import React, {useEffect, useState} from 'react'
import "../css/ThemeManager.css"
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";
import {getTokenFromSession} from "../services/authenticate";
import {deleteTheme, getExistingTheme, saveTheme} from "../Api/InstagramThemeApi";


const frequencyOptions = ['daily', 'alternate days', 'weekly', 'monthly']

const ThemeManager = () => {
    const [selectedTheme, setSelectedTheme] = useState(null)
    const [newThemeName, setNewThemeName] = useState('')
    const [prompt, setPrompt] = useState('')
    const [imagePrompt, setImagePrompt] = useState('')
    const [frequency, setFrequency] = useState('daily')
    const [get, setGet] = useState(true)
    const [allTheme, setAllTheme] = useState([{
        themeName: "",
        prompt: "",
        imagePrompt: "",
        frequency: "",
    }])
    const handleThemeClick = (theme) => {
        setSelectedTheme(theme)
        setPrompt(theme.prompt)
        setImagePrompt(theme.imagePrompt)
        setFrequency(theme.frequency)
    }

    const handleCreateTheme = () => {
        if (!newThemeName.trim()) {
            alert("Please enter a theme name")
            return
        }

        const newTheme = {
            themeName: newThemeName,
            prompt: '',
            imagePrompt: '',
            frequency: 'daily'
        }
        allTheme.push(newTheme)
        setNewThemeName('')
        setSelectedTheme(newTheme)
    }

    useEffect(() => {
        if (get) {
            getFunction().then();
        }
    }, [])
    const getFunction = async () => {
        const token = getTokenFromSession()
        const res = await getExistingTheme();
        if (res.status === 200) {
            setAllTheme(res.data)
            setGet(false)
        }
    }
    const handleSaveTheme = async () => {
        const token = getTokenFromSession()
        const body = {
            themeName: selectedTheme.themeName,
            frequency: frequency,
            prompt: prompt,
            imagePrompt: imagePrompt,
        }
        const res = await saveTheme({body})
        await getExistingTheme()
        if (res.status === 200) {
            setSelectedTheme(null)
            alert("Successfully created theme")
        }
    }


    useEffect(() => {
        if (!selectedTheme) return;
        setAllTheme(prevThemes =>
            prevThemes.map(theme =>
                theme.themeName === selectedTheme.themeName
                    ? {...theme, prompt, frequency}
                    : theme
            )
        );
    }, [prompt, frequency]);


    const handleDeleteTheme = async ({themeName}) => {
        await deleteTheme({themeName})
        setSelectedTheme(null)
        await getFunction();
    }
    return (
        <div>
            <div>
                <Header/>
            </div>
            <div style={{marginTop: "40px"}}>
                <NavBar/>
            </div>
            <div className="theme-manager">
                <div className="sidebar">
                    <div className="create-theme">
                        <input
                            type="text"
                            value={newThemeName}
                            onChange={(e) => setNewThemeName(e.target.value)}
                            placeholder="Enter the New theme name"
                        />
                        <button onClick={handleCreateTheme}>Create Theme</button>
                    </div>
                    <h3>Existing Themes</h3>
                    <div className="tree-view">
                        {allTheme.map((theme) => (
                            <div
                                key={theme.themeName}
                                className={`theme ${selectedTheme?.themeName === theme.themeName ? 'selected' : ''}`}
                                onClick={() => handleThemeClick(theme)}
                            >
                                {theme.themeName}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="main-content">
                    {selectedTheme ? (
                        <div className="theme-view">
                            <h2>{selectedTheme.themeName}</h2>
                            <div className="form-group">
                                <label>GENAI Prompt:</label>
                                <textarea
                                    value={prompt}
                                    onChange={(e) => setPrompt(e.target.value)}
                                    placeholder="Enter your prompt for content generation"
                                />
                            </div>
                            <div className="form-group">
                                <label>Image Prompt</label>
                                <textarea
                                    value={imagePrompt}
                                    onChange={(e) => setImagePrompt(e.target.value)}
                                    placeholder="Enter your prompt for content generation"
                                />
                            </div>
                            <div className="form-group">
                                <label>Posting Frequency:</label>
                                <select
                                    value={frequency}
                                    onChange={(e) => setFrequency(e.target.value)}
                                >
                                    {frequencyOptions.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            < div style={{display: "flex", justifyContent: "space-between"}}>
                                <button className="save-btn" onClick={handleSaveTheme}>Save Theme</button>
                                <button className="delete-btn"
                                        onClick={() => handleDeleteTheme({themeName: selectedTheme.themeName})}
                                >Delete
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="empty-state">Select or create a theme</div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ThemeManager
